import React, { FC, useState } from 'react';

import BugReportModal from '@components/shared/BugReportButton/components/BugReportModal';

import { Button } from 'antd';

import { faBug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

interface BugReportButtonProps {
  scrollBtnVisible?: boolean;
}

export const BugReportButton: FC<BugReportButtonProps> = ({
  scrollBtnVisible,
}) => {
  const [isBugReportModalOpen, setIsBugReportModalOpen] = useState(false);
  return (
    <>
      <Button
        type="default"
        shape="circle"
        className={clsx(
          'fixed bottom-[20px] max-h-[40px] z-50 h-full max-w-[40px] w-full bg-blue border-none hover:bg-black',
          {
            'right-[80px]': scrollBtnVisible,
            'right-[20px]': !scrollBtnVisible,
          },
        )}
        onClick={() => setIsBugReportModalOpen(true)}
      >
        <FontAwesomeIcon icon={faBug} size="xl" className="text-white" />
      </Button>
      <BugReportModal
        isOpen={isBugReportModalOpen}
        closeModal={() => {
          setIsBugReportModalOpen(false);
        }}
      />
    </>
  );
};
